import { FilterValue } from '../../entities';
import { InvoiceStatus } from '../..';
import { InvoicingViewByDays } from './invoicing.enum';


export interface InvoicingViewFilters {
    _id?: string;
    text?: string;
    createdDate?: {
        fromDate: Date;
        toDate: Date;
    };
    contacts?: FilterValue[];
    companies?: FilterValue[];
    createdBy?: FilterValue[];
    status?: InvoiceStatus;
    isError?: boolean;
    dayRange?: InvoicingViewByDays;

    outstandingOnly?: boolean;
    overdueOnly?: boolean;
    prepaymentOnly?: boolean;
}

export interface InvoicingViewFiltersRaw extends InvoicingViewFilters {
    invoiceNumber?: string[];
    total?: number;
}

export function isInvoicingRefined(refinements: InvoicingViewFilters): boolean {

    if (!refinements) return false;

    if (!!refinements?.text) return true;
    if (!!refinements?.contacts?.length) return true;
    if (!!refinements?.companies?.length) return true;
    if (!!refinements?.createdBy?.length) return true;
    if (!!refinements?.createdDate?.fromDate || !!refinements?.createdDate?.toDate) return true;
    if (refinements?.outstandingOnly) return true;
    if (refinements?.overdueOnly) return true;
    if (refinements?.prepaymentOnly) return true;

    return false;
}

